// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderHeader_order__tgtYA {
  color: var(--darkGray);
}

.OrderHeader_header__xKBym {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.OrderHeader_title__VTslY {
  font-family: BebasNeue;
  font-weight: 700;
  color: var(--darkGray);
  font-size: 20px;
}

.OrderHeader_ticketBox__7WMLK {
  display: flex;
  align-items: center;
  background-color: var(--lightGray);
  padding: 5px 10px;
  border-radius: 8px;
  font-weight: 600;
  color: var(--darkGray);
  font-size: 14px;
  margin-bottom: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.OrderHeader_ticketIcon__ySyY8 {
  margin-right: 8px;
  font-size: 18px;
}

.OrderHeader_ticketText__Zdw3s {
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/OrderHeader.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB","sourcesContent":[".order {\n  color: var(--darkGray);\n}\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n}\n\n.title {\n  font-family: BebasNeue;\n  font-weight: 700;\n  color: var(--darkGray);\n  font-size: 20px;\n}\n.ticketBox {\n  display: flex;\n  align-items: center;\n  background-color: var(--lightGray);\n  padding: 5px 10px;\n  border-radius: 8px;\n  font-weight: 600;\n  color: var(--darkGray);\n  font-size: 14px;\n  margin-bottom: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.ticketIcon {\n  margin-right: 8px;\n  font-size: 18px;\n}\n\n.ticketText {\n  font-family: 'Courier New', monospace;\n  letter-spacing: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order": `OrderHeader_order__tgtYA`,
	"header": `OrderHeader_header__xKBym`,
	"title": `OrderHeader_title__VTslY`,
	"ticketBox": `OrderHeader_ticketBox__7WMLK`,
	"ticketIcon": `OrderHeader_ticketIcon__ySyY8`,
	"ticketText": `OrderHeader_ticketText__Zdw3s`
};
export default ___CSS_LOADER_EXPORT___;
